import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const BlogDetails = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(`http://127.0.0.1:8000/api/blog/${slug}/`);
        setBlog(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Blogni olishda xatolik:", err);
        setError("Blog topilmadi");
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) {
    return <p className="text-center mt-40 text-xl">Yuklanmoqda...</p>;
  }

  if (error) {
    return (
      <div className="text-center mt-40">
        <h2 className="text-3xl font-bold text-gray-900">{error}</h2>
        <button
          onClick={() => navigate(-1)}
          className="mt-4 px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
        >
          Ortga qaytish
        </button>
      </div>
    );
  }

  return (
    <section className="mt-32 px-6">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6 relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-0 left-4 text-white bg-black px-3 py-2 rounded-full hover:bg-gray-800 transition"
        >
          &#8592; Ortga
        </button>
        <h1 className="text-4xl font-bold text-gray-900 mb-6 mt-10">{blog.title}</h1>
        <img
          src={`http://127.0.0.1:8000${blog.photo}`}
          alt={blog.title}
          className="w-full h-64 object-cover rounded-md mb-6"
        />
        <p className="text-gray-700 leading-relaxed">{blog.description}</p>
      </div>
    </section>
  );
};

export default BlogDetails;
